import type { OfficerField } from '../types/officer';

export const officerProfile = {
  name: 'এএসআই মোঃ রাকিবুল হাসান',
  bp: 'BP-9214155702',
  designation: 'সহকারী উপ-পরিদর্শক (ASI)',
  unit: 'তেজগাঁও ট্রাফিক বিভাগ, ডিএমপি',
  device: 'DMP-MDM-0457 • Android 14',
  userId: 'dmp.rakib'
};

export const officerOcrFields: OfficerField[] = [
  { key: 'caseNo', label: 'মামলা নম্বর', value: 'DMP/AI/2025/0614/0748', confidence: 98 },
  { key: 'vehicle', label: 'গাড়ির নম্বর', value: 'ঢাকা মেট্রো-গ-২৩-৭১০৭', confidence: 96 },
  { key: 'owner', label: 'মালিকের নাম', value: 'মোঃ মিলন মিয়া', confidence: 91 },
  { key: 'mobile', label: 'মোবাইল', value: '০১৮৩০০৯০৮১৯', confidence: 99 },
  { key: 'offence', label: 'অপরাধের ধরন', value: 'অবৈধ পার্কিং / প্রতিবন্ধ্কতা', confidence: 87 },
  { key: 'date', label: 'তারিখ', value: '১৪/০৬/২০২৫', confidence: 97 },
  { key: 'hearing', label: 'হাজিরার তারিখ', value: '০২/০৭/২০২৫', confidence: 84 }
];

export const officerActivities = [
  { caseNo: 'DMP/AI/2025/0614/0748', vehicle: 'ঢাকা মেট্রো-গ-২৩-৭১০৭', at: '১৪/০৬/২০২৫ ১০:০৪', status: 'যাচাই অপেক্ষমাণ', day: 'আজ' },
  { caseNo: 'DMP/AI/2025/0614/0752', vehicle: 'ঢাকা মেট্রো-খ-১১-৪৫২৩', at: '১৪/০৬/২০২৫ ০৯:৪০', status: 'অনুমোদন অপেক্ষমাণ', day: 'আজ' },
  { caseNo: 'DMP/AI/2025/0613/0688', vehicle: 'ঢাকা মেট্রো-গ-৩৪-৯০১২', at: '১৩/০৬/২০২৫ ১৬:১২', status: 'অনুমোদিত', day: 'গতকাল' },
  { caseNo: 'DMP/AI/2025/0613/0702', vehicle: 'ঢাকা মেট্রো-ঘ-১২-৩৩৪৫', at: '১৩/০৬/২০২৫ ১৪:৫৫', status: 'সংশোধনে ফেরত', day: 'গতকাল' },
  { caseNo: 'DMP/AI/2025/0612/0659', vehicle: 'ঢাকা মেট্রো-খ-১৯-৫৫৭০', at: '১২/০৬/২০২৫ ১১:২০', status: 'অনুমোদিত', day: 'এই সপ্তাহ' },
  { caseNo: 'DMP/AI/2025/0611/0623', vehicle: 'ঢাকা মেট্রো-গ-১৮-৭৭৪৫', at: '১১/০৬/২০২৫ ১০:০৮', status: 'অনুমোদিত', day: 'এই সপ্তাহ' }
];
